import * as _ from 'lodash';

// import store from '@/store';
import ru from '../locales/ru.json';
import en from '../locales/en.json';

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

const LOCALES = { ru, en };

export default function langFilter(s, params) {
  try {
    // const locale = LOCALES[store.getters.lang || 'ru'];
    const locale = LOCALES.ru;
    if (locale[s]) {
      if (params) {
        const compile = _.template(locale[s]);
        return compile(params);
      }

      return locale[s];
    }

    if (!window.mkNewWords) {
      window.mkNewWords = new Set();
    }

    window.mkNewWords.add(s);
    // eslint-disable-next-line no-console
    console.log('New words:', window.mkNewWords);

    return s;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(s, e);
    return s;
  }
}
